import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withStateHandlers, withHandlers } from 'recompose'

import { isEqual, getPaginationObject } from 'utils/misc'

import * as trapModule from 'modules/trap'

export default compose(
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.people.selected),
        traps: idx(state, _ => _.traps.userItems),
        tableLoading: idx(state, _ => _.groups.loading),
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...trapModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      filters: {
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        actions, user, organisation, filters, setPagination
      } = this.props
      if (user && organisation) {
        actions.getUserTraps(user, organisation, filters, setPagination)
      }
    },
    componentDidUpdate(prevProps) {
      const {
        actions, user, organisation, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getUserTraps(user, organisation, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/components/organisms/UserTraps/UserTraps.enhancer.js